import { reactive, readonly } from 'vue'

export type ToastTone = 'success' | 'error' | 'info'

export interface Toast {
  id: number
  text: string
  tone: ToastTone
}

const items = reactive<Toast[]>([])
let nextId = 1

export function notify(text: string, tone: ToastTone = 'info'): void {
  const id = nextId++
  items.push({ id, text, tone })
  window.setTimeout(() => dismiss(id), tone === 'error' ? 6_000 : 3_800)
}

export function dismiss(id: number): void {
  const index = items.findIndex((item) => item.id === id)
  if (index >= 0) items.splice(index, 1)
}

export function useToasts() {
  return {
    items: readonly(items),
    dismiss,
  }
}
